export default (theme) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2),
  },
  error: {
    display: 'block',
    marginTop: theme.spacing(0.5),
    color: theme.palette.textColor.red,
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(0.5),
  },
});
